import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

import { BetslipConfig, BetslipUpsellConfig } from '@frontend/sports/common/client-config-data-access';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';

import { getModuleTypesOrder } from '../../../base/utils/linear-utils';
import { BetslipType } from '../../../core/betslip-type';
import { LinearTypes } from '../../../core/linear-types';
import { RemoveButtonStyle } from '../../../modules/picks/components/digital/pick-remove-button/remove-button-style';
import { RemoveButtonPosition } from '../../../modules/single-bet/remove-button-position-enum';

@Component({
    selector: 'bs-betslip-linear-type-list',
    templateUrl: './betslip-linear-type-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BetslipLinearTypeListComponent implements OnChanges, AfterViewInit {
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() obj: {
        tabProps: { selectedBetslipType: BetslipType | null; activeBetslipTypes: BetslipType[]; linearTypes: LinearTypes };
    };

    @Input() scrollerMinHeight: string;
    @ViewChild('scroller') scroller: ElementRef;
    removeButtonPosition = RemoveButtonPosition;
    readonly removeButtonStyle = RemoveButtonStyle;
    readonly betslipTypes = BetslipType;
    linearBetslipTypesOrder: BetslipType[];

    readonly isBetBuilderModuleEnabled: boolean;

    constructor(
        public betslipUpsellConfig: BetslipUpsellConfig,
        private betslipConfig: BetslipConfig,
    ) {
        this.isBetBuilderModuleEnabled = this.betslipConfig.isLinearSeparateBetBuilderModuleEnabled;
        const configuredOrder = this.betslipConfig.linearBetslipTypesOrder;
        this.linearBetslipTypesOrder = getModuleTypesOrder(configuredOrder);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['scrollerMinHeight'] && this.scroller?.nativeElement) {
            this.scroller.nativeElement.style.minHeight = changes['scrollerMinHeight'].currentValue;
        }
    }

    ngAfterViewInit() {
        if (this.scroller?.nativeElement) {
            this.scroller.nativeElement.style.minHeight = this.scrollerMinHeight;
        }
    }

    get isBetBuilderModuleActive(): boolean {
        return this.isActive(BetslipType.BetBuilder) && this.isBetBuilderModuleEnabled;
    }

    get isComboModuleActive(): boolean {
        return this.isActive(BetslipType.Combo) || (this.isActive(BetslipType.BetBuilder) && !this.isBetBuilderModuleEnabled);
    }

    isActive(betslipType: Exclude<BetslipType, BetslipType.EditBet>): boolean {
        return this.obj.tabProps.activeBetslipTypes.includes(betslipType) && !!this.obj.tabProps.linearTypes[betslipType];
    }
}
